<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="loading"
      :default-expand-all="true"
      border
      fit
      stripe
    >
      <el-table-column
        prop="sortNum"
        label="序号"
        min-width="60"
        align="center"
      />
      <el-table-column
        prop="eleName"
        label="主要从事的专业方向（研究学科）"
        min-width="200"
      />
      <el-table-column prop="threeName" label="二级专业" min-width="100" />
      <el-table-column
        prop="needCount"
        label="需要抽取数"
        min-width="100"
        align="center"
      />
      <el-table-column label="抽取需求" min-width="300">
        <template slot-scope="scope">
          专业技术职称:[
          <b v-text="scope.row.appellation"></b>
          ]; 人员行业分类:[
          <b v-text="scope.row.industry"></b>
          ]; 行政级别:[
          <b v-text="scope.row.executLevel"></b>
          ]; 同一单位:
          <b v-text="scope.row.deptRepCount"></b>
        </template>
      </el-table-column>
      <el-table-column
        prop="actualCount"
        label="实际抽取数"
        min-width="100"
        align="center"
      />
    </el-table>
  </div>
</template>

<script>
import { listReviews } from '@/api/gains/para.js';

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0
    };
  },
  props: {
    batchEid: {
      type: String
    }
  },
  methods: {
    listParas() {
      this.loading = true;
      listReviews(this.$route.params.gainEid, this.batchEid).then(res => {
        this.tableData = res;
        this.loading = false;
      });
    }
  },
  created() {
    this.listParas();
  }
};
</script>

<style></style>
